module.exports = __webpack_public_path__ + "images/Delete_new.svg";